<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <ng-template #dataPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Choose organization</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="padding: 2%;">
      <div class="row">
        <div><label for="reasonForSignature">Dropdown</label><span
            class="mandatory-symbol">*</span></div>
        <div> <ng-multiselect-dropdown
          class="multiselect-container" [(ngModel)]="selectedValue"
            [settings]="singleSelectDropdownSetting" [data]="dropDownList" (onSelect)="onDropdownSelect($event)"
            (onDeSelect)="onDropdownRemoved($event)">
          </ng-multiselect-dropdown>
        </div>
        
      </div>
      </div>
      <div class="button-continer btn-align"  mat-dialog-actions>
        <button (click)="logoutFunction()"  mat-stroked-button class="addButton">
          Login
        </button>
        <button  (click)="logutCancel()" mat-stroked-button class="cancelButton">
          <i class="fa fa-close"></i> Logout
        </button>
      </div>
    
  </ng-template>